var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{attrs:{"width":"95%","top":"5vh","visible":_vm.visible},on:{"close":_vm.handleClose}},[_c('div',{ref:"detail",staticStyle:{"height":"620px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }